<template>
    <div class="pool">

        <div class="list_box" v-if="NavTree && NavTree.length > 0">
            <van-collapse v-model="activeNames" v-for="(item,index) in NavTree" :key="index"  
            :style="{'border':'1px solid #3641C9','margin-top':'0.15rem'}">
            <!-- <el-card> -->
                <van-collapse-item :name="index">
                    <template #title>
                            <div>{{ item.DisplayName }}</div>
                    </template>
                        <template>
                            <div>
                                <van-collapse v-model="activeNamesc" v-for="(items) in item.Children" :key="items.PhaseId"  
                                    :style="{'border':'1px solid #3641C9','margin-top':'0.15rem'}" v-show="items.PhaseIsPool  == 1">
                                    <!-- <el-card> -->
                                        <van-collapse-item :name="items.PhaseId" v-if="items.PhaseIsPool  == 1">
                                            <template #title>
                                                    <div>{{ items.DisplayName }}</div>
                                            </template>
                                                <template>
                                                    <div>
                                                        <van-collapse v-model="activeNamescc"   
                                                            :style="{'border':'1px solid #3641C9','margin-top':'0.15rem'}">
                                                            <!-- <el-card> -->
                                                                <van-collapse-item :name="iii.PhaseId" v-for="(iii) in items.Children" :key="iii.PhaseId" disabled
                                                                :style="{'border-bottom':'1px solid #3641C9'}">
                                                                    <template #title>
                                                                            <div>{{ iii.DisplayName }}</div>
                                                                    </template>
                                                                    <template  #right-icon >
                                                                        <div class="icons" ><i @click.stop="handPDF(iii)" class="iconfont icon-pdf"></i></div>
                                                                    </template>
                                                                </van-collapse-item>
                                                            <!-- </el-card> -->
                                                            </van-collapse>
                                                    </div>
                                                </template>
                                            <template  #right-icon >
                                                <div class="icons" ><i @click.stop="handPDF(items)" class="iconfont icon-pdf"></i></div>
                                            </template>
                                        </van-collapse-item>
                                    <!-- </el-card> -->
                                    </van-collapse>
                            </div>
                        </template>
                    <template  #right-icon >
                        <div class="icons" ><i class="van-icon van-icon-arrow van-cell__right-icon"></i></div>
                    </template>
                </van-collapse-item>
            <!-- </el-card> -->
            </van-collapse>
        </div>
        <van-empty v-else description="暂无相关比赛数据。。。" />
        <el-dialog width="90%" :visible.sync="pdfVisible">
            <!-- <pdf :src="pdfUrl" ref="pdf" v-for="i in numPages" :key="i" :page="i"></pdf> -->
            <div id="demo"></div>
        </el-dialog>
    </div>
</template>

<script>
import mNav from "@/components/mNav.vue";
import NaList from '@/assets/common/nav.json';
import tree from '@/assets/common/NavTree.json';
import http from '@/assets/js/http.js';
import axios from 'axios';
import {Loading} from 'element-ui';
import { Dialog,ImagePreview } from 'vant';
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
export default {
    name: "Pool",
    components: {
        mNav,
    },
    data() {
        return {
            msg: sessionStorage.SportName,
            isActive: 0,
            NaList: NaList,
            NavTree: [],
            activeNames:[],
            activeNamesc: [],
            activeNamescc: [],
            pdfVisible: false,
            pdfh5: null,
        }
    },
    mounted() {
        // console.log(console.log(this.$route);)
        // console.log(this.$route);   
        // console.log(this.NavTree);
        http.GetFile('/Sports/BDM/BDM20240414/NavTree.json?v='+Math.random()).then(res=>{//获取赛事列表地址
            console.log(res)
            if(Array.isArray(res)){
                this.NavTree = res;
            }else{
                this.NavTree = [];
            }
            
        })
        // this.isActive = this.$route.query.isActive;
    },
    methods: {
        handPDF(i){
            console.log(i)
            let index = i.FileName .lastIndexOf(".")
            let str = i.FileName.substring(index+1,i.FileName.length);
            console.log(str) //
            axios.get('/Sports/BDM/BDM20240414/Files/'+i.FileName+'?v='+Math.random()).then(res=>{
                console.log(res)
                if(res.status == 200) {
                    if(str.toLowerCase() == 'png' && str.toLowerCase() == 'jpg' && str.toLowerCase() == 'jpeg' && str.toLowerCase() == 'gif'){
                        ImagePreview(['http://assess.holy-sport.com:8001/Sports/BDM/BDM20240414/Files/'+i.FileName+'?v='+Math.random()]);
                    }else {
                        window.open('http://assess.holy-sport.com:8001/Sports/BDM/BDM20240414/Files/'+i.FileName+'?v='+Math.random());
                    }
                }else{
                    Dialog.alert({
                        message: '暂未上传该比赛文件'
                    }).then(() => {
                        let loadingInstance = Loading.service();
                        this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                            loadingInstance.close();
                        });
                    });
                }
            })
        }
    },
}
</script>

<style lang="scss" scoped>
    $bgColor: #3641C9;
    ::v-deep .van-collapse-item__title--disabled, .van-collapse-item__title--disabled .van-cell__right-icon{
        color: #333;
    }
    ::v-deep .pinch-zoom-container{
        min-height: 450px;
        height: auto;
    }
    .pool{
        font-size: 20px;
    }
    .list_box{
        padding: 20px;
    }
    .lis{
        padding: 20px 0;
        background: white;
        border-bottom: 1px solid $bgColor;
        text-indent: 30px;
        font-size: 30px;
    }
</style>